import * as React from 'react'
import DigitalDegreeLogo from './DigitalDegreeLogo'
import { useForcedViewTheme } from '../theme'
import ViewOther from './ViewOther'

function setFavicon(faviconBase64: string) {
  const link: HTMLLinkElement =
    document.querySelector("link[rel~='icon']") ??
    (() => {
      const newLink = document.createElement('link')
      newLink.rel = 'icon'
      document.head.appendChild(newLink)
      return newLink
    })()
  link.href = faviconBase64
}

export default function Header() {
  const theme = useForcedViewTheme()
  const base = 'Visualizar documento'
  const institutionName = theme.publicViewInstitutionName
  const title = institutionName ? `${institutionName} - ${base}` : base

  React.useEffect(() => {
    if (theme.faviconBase64) {
      setFavicon(theme.faviconBase64)
    }
  }, [theme.faviconBase64])

  return (
    <div className="bg-white border-b border-[#00000020] ">
      <title>{title}</title>
      <div className="bg-white md:flex-row flex-col flex gap-4 md:gap-2 items-center justify-between w-full px-4 lg:px-0 py-4 md:py-2 max-w-6xl mx-auto">
        <div className="flex gap-2 items-center w-full">
          <div className="w-auto">
            <DigitalDegreeLogo />
          </div>
          <div className="flex justify-between w-full items-center gap-1">
            <p
              style={{ color: theme.publicViewPrimaryColor }}
              className="border-l text-lg pl-4 ml-4 border-[#00000020]"
            >
              {institutionName}
            </p>
            <p className="text-right flex-1 font-medium text-sm text-gray-500">
              {theme.documentSeeType}
            </p>
          </div>
        </div>
        <ViewOther className="md:flex hidden" />
      </div>
    </div>
  )
}
